import { render, staticRenderFns } from "./ImagesZoom.vue?vue&type=template&id=21f98154&scoped=true&"
import script from "./ImagesZoom.vue?vue&type=script&lang=js&"
export * from "./ImagesZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImagesZoom.vue?vue&type=style&index=0&id=21f98154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f98154",
  null
  
)

export default component.exports